import api from '@http/api';

export interface IApproveSolicitacao {
  solicitacoes_programa_id: number[];
  NovoStatusSolicitacao: any;
}

class ComponentSolicitacaoServices {
  public async ApproveSolicitacao({ solicitacoes_programa_id, NovoStatusSolicitacao }: IApproveSolicitacao) {
    return await api
      .patch('/api/SolicitacaoPrograma/UpdateAprovarStatusSolicitacoesPrograma', {
        solicitacoes_programa_id,
        NovoStatusSolicitacao
      })

      .then(response => {
        return {
          error: false,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }
}

export default ComponentSolicitacaoServices;
